<div class="container schnellbuchen py-4">
    <div class="mb-4">
        <h2 class="mb-1">Schnellbuchen</h2>
        <p class="mb-0">In drei Schritten zum gebuchten Kind. Erst Eltern, dann Kind, dann Buchung starten.</p>
    </div>

    <div class="row">
        <div class="col-lg-6 mb-3">
            <div class="card step-card h-100">
                <div class="card-body h-100 d-flex flex-column">
                    <div class="d-flex align-items-center mb-2">
                        <span class="step-number">1</span>
                        <h5 class="mb-0">Eltern w&auml;hlen</h5>
                        <span class="badge badge-success ml-2" *ngIf="eltern">Ausgew&auml;hlt</span>
                    </div>
                    <p class="">W&auml;hle einen bestehenden Account oder lege einen neuen Elternteil an.</p>

                    <ng-container *ngIf="eltern; else noEltern">
                        <div class="selection-pill mb-3">
                            <div class="font-weight-bold">{{ eltern.vorname }} {{ eltern.nachname }}</div>
                            <div class="small ">{{ eltern.mail || '---' }}</div>
                            <div class="small ">{{ eltern.strasse }} {{ eltern.hausnummer }}, {{ eltern.plz }} {{ eltern.ort }}</div>
                            <div class="small ">Kinder: {{ eltern.kinder.length }}</div>
                        </div>
                        <div class="flex-grow-1"></div>
                        <div class="d-flex flex-wrap flex-row">
                            <button class="btn pcButton mr-2" (click)="selectEltern()">Eltern wechseln</button>
                            <button class="btn scButton" (click)="clearEltern()">Auswahl l&ouml;schen</button>
                        </div>
                    </ng-container>
                    <ng-template #noEltern>
                        <div class="flex-grow-1"></div>
                        <div class="d-flex flex-wrap flex-row">
                            <button class="btn pcButton mr-2" (click)="createEltern()">Neu anlegen</button>
                            <button class="btn scButton" (click)="selectEltern()">Ausw&auml;hlen</button>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>

        <div class="col-lg-6 mb-3">
            <div class="card step-card h-100" [class.disabled]="!eltern">
                <div class="card-body h-100 d-flex flex-column">
                    <div class="d-flex align-items-center mb-2">
                        <span class="step-number">2</span>
                        <h5 class="mb-0">Kind w&auml;hlen</h5>
                        <span class="badge badge-success ml-2" *ngIf="kind">Ausgew&auml;hlt</span>
                    </div>
                    <p class="">Kinder werden dem aktuell ausgew&auml;hlten Elternteil zugeordnet.</p>

                    <ng-container *ngIf="eltern; else noParent">
                        <ng-container *ngIf="kind; else noKind">
                            <div class="selection-pill mb-3">
                                <div class="font-weight-bold">{{ kind.vorname }} {{ kind.nachname }}</div>
                                <div class="small ">{{ kind.geburtsdatum | ageFilter }} Jahre alt</div>
                                <div class="small ">{{ kind.strasse }} {{ kind.hausnummer }}, {{ kind.plz }} {{ kind.ort }}</div>
                            </div>
                            <div class="flex-grow-1"></div>
                            <div class="d-flex flex-row flex-wrap">
                                <button class="btn pcButton mr-2" (click)="selectKind()">Kind wechseln</button>
                                <button class="btn scButton" (click)="clearKind()">Auswahl l&ouml;schen</button>
                            </div>
                        </ng-container>
                        <ng-template #noKind>
                            <div class="flex-grow-1"></div>
                            <div class="d-flex flex-row flex-wrap">
                                <button class="btn pcButton mr-2" (click)="createKind()">Neu anlegen</button>
                                <button class="btn scButton" (click)="selectKind()" [disabled]="eltern.kinder.length === 0">Ausw&auml;hlen</button>
                            </div>
                            <p class="small mt-2" *ngIf="eltern.kinder.length === 0">Dieser Elternteil hat noch keine Kinder.</p>
                        </ng-template>
                    </ng-container>
                    <ng-template #noParent>
                        <p class=" mb-0">Bitte zuerst einen Elternteil ausw&auml;hlen.</p>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>

    <div class="card step-card" [class.disabled]="!kind">
        <div class="card-body d-flex flex-column flex-lg-row justify-content-between align-items-lg-center">
            <div class="mb-3 mb-lg-0">
                <div class="d-flex align-items-center mb-2">
                    <span class="step-number">3</span>
                    <h5 class="mb-0">Buchung starten</h5>
                </div>
                <p class=" mb-0">Nach dem Ausw&auml;hlen kannst du direkt zur Buchungsmaske springen.</p>
            </div>
            <button class="btn pcButton" [disabled]="!kind" (click)="goToBuchung()">Kind buchen</button>
        </div>
    </div>
</div>
